<template>
    <div class="d-flex" :class="($vuetify.breakpoint.mdAndUp) ? 'flex-row' : 'flex-column'" style="height: 100%;">
        <DialogoPreAfi ref="refPreAfi" titulo="Formulario" type="afiliacion" />
        <v-card v-if="$vuetify.breakpoint.mdAndUp" max-width="50%" width="50%" flat color="grey darken-2"
            class="d-flex rounded-0">
            <v-img src="@/assets/afiliacion/img-afiliacion.png"
                style="position: sticky; top: 0; height: 100vh; object-fit: cover; width: auto" />
            <FabRedesSociales style="position: fixed; left: 16px; z-index: 1000;">
            </FabRedesSociales>
        </v-card>
        <v-card :max-width="($vuetify.breakpoint.smAndDown) ? '100%' : '50%'" width="100%"
            class="custom-card justify-center" flat>
            <v-card flat v-if="currentIndex !== itemsPreafi.length" width="98%">
                <v-card-text v-if="!$vuetify.breakpoint.mdAndDown" class="d-flex justify-center mt-5 mb-5">
                    <v-img max-width="275px" src="@/assets/Logo-bt-07.png" contain />
                </v-card-text>
                <v-card-text class="pa-0 d-flex justify-center font-weight-bold text-h6 primary--text my-2">
                    ¿Qué necesitás?
                </v-card-text>
                <v-card-text class="d-flex justify-center">
                    <CarouselCard style="scale: 0.98;" :items="itemsPreafi[currentIndex]"
                        class="d-flex flex-column justify-center align-center">
                    </CarouselCard>
                </v-card-text>
            </v-card>
            <v-card v-else flat :class="$vuetify.breakpoint.mdAndDown ? 'mt-5' : ''">
                <v-card class="d-flex flex-column align-center justify-start rounded-0" flat>
                    <v-card-text v-if="$vuetify.breakpoint.mdAndUp" class="d-flex justify-center mt-5 mb-8">
                        <v-img max-width="275px" src="@/assets/Logo-bt-07.png" contain />
                    </v-card-text>
                    <v-card-text class="px-8">
                        <v-form @submit.prevent="submit">
                            <ValidationObserver ref="obs" v-slot="{ invalid }">
                                <v-row class="align-center justify-center px-8">
                                    <v-col cols="12" md="9">
                                        <v-text-field name="Nro de Matricula" outlined :maxlength="6"
                                            v-model="nuevoAfiliado.matricula" ref="nromatricula" type="text" readonly
                                            @keydown="preventArrowKeys" hide-spin-buttons label="Nº matrícula"
                                            @input="onInputMatricula">
                                        </v-text-field>
                                        <v-text-field name="DNI" outlined v-model="nuevoAfiliado.dniafi" type="text"
                                            readonly @keydown="preventArrowKeys" hide-spin-buttons label="Número de dni"
                                            @input="onInputDNI" :maxlength="8">
                                        </v-text-field>
                                        <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                                            <v-checkbox v-model="nuevoAfiliado.checkbox" :error-messages="v.errors[0]"
                                                input-value="false" value @change="evaluarCheck">
                                                <template v-slot:label>
                                                    <div
                                                        :class="(nuevoAfiliado.checkbox) ? `font-weight-medium primary--text` : `black--text font-weight`">
                                                        Tengo toda la documentación necesaria.
                                                    </div>
                                                </template>
                                            </v-checkbox>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" md="9">
                                        <v-alert colored-border color="orange" border="left" elevation="0"
                                            class="ma-0 pa-5 rounded-0">
                                            <div v-for="item in infoAfiliacion" :key="item.text"
                                                v-html="formatText(item.text)"
                                                class="pa-2 font-weight-regular text-body-1">
                                            </div>
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12" md="12" class="d-flex justify-center">
                                        <v-btn type="submit" @keyup.enter="submit" :disabled="invalid" elevation="0"
                                            :loading="loading" color="primary" class="pa-6 mb-3">
                                            <v-icon class="mr-2">mdi-open-in-app</v-icon>
                                            completar formulario
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </ValidationObserver>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-card>
            <v-card-actions class="d-flex justify-space-between align-center"
                :class="($vuetify.breakpoint.mdAndUp) ? 'custom-card-actions' : 'custom-card-actions-middle'">
                <v-btn @click="atras" outlined color="secondary" elevation="0" class="pa-5">
                    <v-icon class="mr-2">mdi-chevron-left</v-icon>
                    ATRAS
                </v-btn>
                <v-btn v-if="currentIndex < itemsPreafi.length" class="pa-5" color="primary" @click="siguiente"
                    elevation="0" @keyup.enter="submit">
                    <v-icon class="mr-2">mdi-chevron-right</v-icon>
                    SIGUIENTE
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>


<script>

import CarouselCard from '@/components/cards/CarouselCard.vue';
import FabRedesSociales from '@/components/fabs/FabRedesSociales.vue';
import DialogoConfirmar from '@/components/dialogos/DialogoConfirmar.vue';
import DialogoPreAfi from '@/components/dialogos/DialogoPreAfi.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    name: 'PreAfiliacion',
    components: {
        DialogoPreAfi,
        DialogoConfirmar,
        CarouselCard,
        FabRedesSociales,
        // AfiliacionCard,
        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            nuevoAfiliado: {
                matricula: '',
                dniafi: '',
                checkbox: '',
            },
            infoAfiliacion: [
                {
                    id: 1, text: "La afiliación se debe completar dentro de los 30 días posteriores a la matriculación. Para decidir el nivel de aportes se debe pensar qué haber jubilatorio desea recibir y por supuesto, cuánto puede pagar mensualmente."
                },
                {
                    id: 2, text: "Recordá que de no completar el legajo de afiliación dentro de los 30 días de tu matriculación se te incluirá automáticamente en el nivel 2."
                },
            ],
            titulo: '',
            label: '',
            currentIndex: 0,
            loading: false,
            itemsPreafi: [
                { tipo: 'personales', title: 'DATOS PERSONALES', doble: true, list: ['Nombre y apellido', 'DNI', 'CUIL', 'Fecha de nacimiento', 'Nacionalidad', 'Estado civil', 'Certificado de discapacidad (si corresponde)', 'Nombre y apellido de padres'] },
                { tipo: 'hijos', title: 'DATOS DE HIJOS', doble: true, subtitle: '(si corresponde)', list: ['Nombre y apellido', 'DNI', 'CUIL', 'Fecha de nacimiento', 'Nacionalidad', 'Certificado de discapacidad (si corresponde)'] },
                { tipo: 'conyuge', title: 'DATOS DEL CÓNYUGE O CONVIVIENTE', doble: true, subtitle: '(si corresponde)', list: ['Nombre y apellido', 'DNI', 'CUIL', 'Fecha de nacimiento', 'Nacionalidad'] },
                { tipo: 'contacto', title: 'DATOS DE CONTACTO', doble: false, list: ['Domicilios', 'Teléfonos', 'Correo electrónico'] },
                { tipo: 'profesionales', title: 'TUS DATOS PROFESIONALES', doble: false, list: ['Nro. de matrícula', 'Fecha de matriculación', 'Fecha de expedición de título'] },
                { tipo: 'documentacion', title: 'DOCUMENTACIÓN ESCANEADA', subtitle: "Personal y profesional", doble: true, list: ['DNI de afiliado (frente y dorso)', 'Título profesional (frente y dorso)', 'Certificado de Discapacidad (si corresponde)', 'Recibo de sueldo (si corresponde)', 'Historial de matrícula expedido por el colegio de psicólogos (si corresponde)', 'Certificado laboral (si corresponde)'] },
                { tipo: 'documentacion', title: 'DOCUMENTACIÓN ESCANEADA', subtitle: "Familiares (si corresponde)", doble: true, list: ['Acta o partida de matrimonio/convivencia, Información Sumaria o Certificado de Convivencia', 'PARTIDA/S DE NACIMIENTO expedida por el Registro de las Personas (acompañar con la hoja adicional de firmas o sello del registro)', 'DNI de hijos, cónyuge o conviviente (frente y dorso)', 'Certificado de Discapacidad de hijos (si corresponde)'] },
            ]
        }
    },
    computed: {
        ...mapGetters('preafiliacion', ['matricula', 'preafi']),
        ...mapGetters(['nroAfiDoc', 'numeroAfi', 'numeroDoc']),
    },

    mounted() {
        if (this.preafi) {
            this.setPreAfi(false)
        }
        if (this.numeroAfi && this.numeroDoc) {
            this.nuevoAfiliado.matricula = this.numeroAfi
            this.nuevoAfiliado.dniafi = this.numeroDoc.toString()

            // Forzar validación después de asignar valores del store
            this.$nextTick(() => {
                if (this.$refs.obs) {
                    this.$refs.obs.validate();
                }
            });
        }
        else {
            console.log('volver')
            this.$router.push('/RecuperarPassword').catch(() => { })
        }
        window.scrollTo(0, -50)
    },
    methods: {
        ...mapMutations('preafiliacion', ['setPreAfi']),
        ...mapActions('preafiliacion', ['guardarMatricula', 'getValidarAfiliado']),
        ...mapActions('common', ['getItemsNivel']),

        submit() {
            let vm = this
            this.loading = true
            this.titulo = 'Formulario'
            this.$refs.obs.validate().then(result => {
                if (result) {
                    let obj = { 'nroafi': this.nuevoAfiliado.matricula, 'nrodni': this.nuevoAfiliado.dniafi }
                    vm.getValidarAfiliado(obj).then(() => {
                        this.loading = false
                    })
                }
            })
        },
        formatText(text) {
            const boldsText = ['La afiliación se debe completar dentro de los 30 días posteriores a la matriculación.', 'nivel 2'];
            boldsText.forEach(boldText => {
                const regex = new RegExp(`(${boldText})`, 'gi');
                text = text.replace(regex, '<strong>$1</strong>');
            });
            return text;
        },
        siguiente() {
            if (this.currentIndex < this.itemsPreafi.length) {
                this.currentIndex++
            }
        },
        atras() {
            if (this.currentIndex > 0) {
                if (this.currentIndex == this.itemsPreafi.length + 1) {
                    this.$router.push('/login').catch(() => { })
                } else {
                    this.currentIndex--
                }
            } else {
                this.$router.push('/login').catch(() => { })
            }
        },
        atras() {
            if (this.currentIndex == 0) {
                this.$router.push('/login').catch(() => { })
            } else {
                this.currentIndex--
                this.$refs.carousel.atras()
            }
        },
        onCarouselIndexChange(newIndex) {
            this.currentIndex = newIndex
        },
        lanzaDialogoPreAfi() {
            this.loading = true
            this.titulo = 'Formulario'
            this.$refs.dialogConfirmar.abrirDialogo().then((result) => {
                if (result) {

                } else {
                    this.loading = false
                }
            })

        },
        evaluarCheck() {
            this.$refs.obs.validate();
            if (this.nuevoAfiliado.checkbox == true) {
                this.$refs.nromatricula.focus()

                window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: 'smooth'
                })
            }

        },
        goToHome() {
            this.$router.push('/login').catch(() => { })
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        onInputMatricula(e) {
            // Limita el valor a 6 caracteres y solo números
            if (this.nuevoAfiliado.matricula) {
                this.nuevoAfiliado.matricula = this.nuevoAfiliado.matricula.replace(/\D/g, '').slice(0, 6);
            }
        },
        onInputDNI(e) {
            // Limita el valor a 8 caracteres y solo números
            if (this.nuevoAfiliado.dniafi) {
                this.nuevoAfiliado.dniafi = this.nuevoAfiliado.dniafi.replace(/\D/g, '').slice(0, 8);
            }
        },
    },

}

</script>

<style>
.logo-image {
    max-width: 100%;
    /* Ajusta esto según sea necesario */
    height: auto;
    /* Mantiene la proporción de la imagen */
    object-fit: cover;

}

.espacio-lista {
    margin: 0 0 0 0;
    min-height: min-content;
    padding: 0 0 0 0;
}

.form-footer {
    position: absolute;
    bottom: 0;
    right: 10px;
    display: flex;
    gap: 10px;
    /* Añade espacio entre los botones */
}

.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para las acciones */
}

.custom-card-actions {
    position: fixed;
    /* Fijo en la parte inferior */
    bottom: 0;
    left: 50%;
    right: 0;
    height: 65px;
    /* Ajusta la altura según sea necesario */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    /* Asegúrate de que esté por encima del contenido */
}

.custom-card-actions-middle {
    position: fixed;
    /* Fijo en la parte inferior */
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    /* Ajusta la altura según sea necesario */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    /* Asegúrate de que esté por encima del contenido */
}

.background-fixed {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* Centra la imagen en su contenedor */
    width: 100%;
    height: auto;
}

.img-difuminada {
    mask-image: linear-gradient(to bottom, transparent 0%, white 30%, white 70%, transparent 100%);
    -webkit-mask-image: linear-gradient(to bottom, transparent 0%, white 30%, white 70%, transparent 100%);
}
</style>